import script from "./bonusomat-quest-detail-accordion.vue?vue&type=script&lang=ts&setup=true"
export * from "./bonusomat-quest-detail-accordion.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__